"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationCosts = require("../../../../hooks/recommendation/useRecommendationCosts");
var _services = require("../../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../../../hooks/useLocalTheme"));
var _PaymentOptionsModal = require("./PaymentOptionsModal");
var _useCustomer = require("../../../../hooks/questionnaire/useCustomer");
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _questionnaireSelectors = require("../../../../store/questionnaire/questionnaireSelectors");
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _constants = require("../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  & [class^='Headingstyle__Heading-sc-'] {
    white-space: nowrap;
  }
  padding: 0 !important;
`;
const StyledDiv = _styledComponents.default.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  ${_r10SourceLibrary.Mixins.respondTo.md(` align-items: ${props => props.alignItems};`)}
`;
const OnlineDiscountPill = _styledComponents.default.div`
  background-color: #42e8b4;
  padding: 2px 4px;
  width: max-content;
  color: #000000;
  border-radius: 3px;
`;
const StyledSpan = _styledComponents.default.span`
  margin-top: 6px;
  button {
    box-shadow: none !important;
  }
`;
const TermCostContainer = _styledComponents.default.div`
  margin-top: ${props => props.adjustPriceLayout ? '-5px' : '0px'};
`;
const StyledInteraction = (0, _styledComponents.default)(_r10SourceLibrary.Interaction)`
  text-align: left;
  box-shadow: none !important;
`;
const Prices = _ref => {
  var _metadata$flags;
  let {
    handsetIndex = null
  } = _ref;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    handsetTermCost,
    handsetUpfrontCost,
    termDuration,
    discountPrices
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const showPaymentSection = (0, _useConfig.default)('paymentModal.showPaymentSection');
  const metadata = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  const showPaymentEntryPoint = isCustomer || showPaymentSection || (metadata === null || metadata === void 0 ? void 0 : (_metadata$flags = metadata.flags) === null || _metadata$flags === void 0 ? void 0 : _metadata$flags[_constants.FLAGS.NEXT_FLOW]);
  const {
    discountPriceValue,
    discountPercentage
  } = discountPrices;
  const priceValue = discountPriceValue > 0 ? discountPriceValue : handsetUpfrontCost;
  const originalPriceValue = discountPriceValue > 0 && handsetUpfrontCost;
  const adjustPriceLayout = (0, _useLocalTheme.default)('recommendation.adjustPriceLayout', false);
  const hideDiscount = (0, _useConfig.default)('hideDiscount', false);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const hideDiscountPercentage = hideDiscount && discountPercentage < minimumDiscount;
  const initialConstLabel = /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: breakpoints.sm && !adjustPriceLayout && 'center',
    dataAttributes: {
      'data-test-id': `initial-price-title-${handsetIndex}`
    },
    noMargin: true
  }, _services.Services.locale.localeString('Recommendation.StickyFooterUpfront'));
  const [isPaymentModalOpen, setPaymentModalOpen] = (0, _react.useState)(false);
  const FinancingWithBanks = _services.Services.locale.localeString('Recommendation.FinancingWithBanks', {
    allowMissingKey: true,
    defaultValue: ''
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!discountPercentage && initialConstLabel, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: adjustPriceLayout ? 1 : 2,
      md: 2
    },
    spacing: adjustPriceLayout ? 9 : 3,
    justify: breakpoints.sm && 'center'
  }, priceValue > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    columns: {
      sm: 1,
      md: 1
    },
    spacing: 0
  }, !discountPercentage && initialConstLabel, !!discountPercentage && !hideDiscountPercentage && /*#__PURE__*/_react.default.createElement(OnlineDiscountPill, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    noMargin: true,
    justify: "center",
    size: 1,
    weight: 2,
    dataAttributes: {
      'data-test-id': `discount-${handsetIndex}`
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, `${Math.round(discountPercentage)}%`), ' ', _services.Services.locale.localeString('Recommendation.onlineDiscount'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    appearance: "secondary",
    weight: 3,
    justify: breakpoints.sm && !adjustPriceLayout && 'center',
    text: _services.Services.locale.formatPrice(priceValue),
    dataAttributes: {
      'data-test-id': `discounted-price-${handsetIndex}`
    },
    noMargin: true
  }), originalPriceValue && originalPriceValue !== priceValue && !hideDiscountPercentage && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-test-id': `actual-price-${handsetIndex}`
    }
  }, _services.Services.locale.localeString('Recommendation.was'), ' ', /*#__PURE__*/_react.default.createElement("del", null, _services.Services.locale.formatPrice(originalPriceValue))))), handsetTermCost > 0 && showPaymentEntryPoint && /*#__PURE__*/_react.default.createElement(TermCostContainer, {
    adjustPriceLayout: adjustPriceLayout
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    columns: {
      sm: 1,
      md: 1
    }
  }, !FinancingWithBanks && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: breakpoints.sm && !adjustPriceLayout && 'center',
    dataAttributes: {
      'data-test-id': `recurring-price-title-${handsetIndex}`
    },
    noMargin: true
  }, _services.Services.locale.localeString('Recommendation.StickyFooterMonthly')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    justify: breakpoints.sm && !adjustPriceLayout && 'center',
    text: _services.Services.locale.formatPrice(handsetTermCost),
    dataAttributes: {
      'data-test-id': `recurring-price-${handsetIndex}`
    },
    noMargin: true
  })), !!termDuration && /*#__PURE__*/_react.default.createElement(StyledDiv, {
    alignItems: FinancingWithBanks ? 'flex-start' : 'center'
  }, /*#__PURE__*/_react.default.createElement(_PaymentOptionsModal.PaymentOptionsModal, {
    isOpen: isPaymentModalOpen,
    setIsOpen: setPaymentModalOpen
  }), /*#__PURE__*/_react.default.createElement(StyledSpan, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.InteractiveIcon, {
    onClick: () => setPaymentModalOpen(true),
    isResponsive: true,
    name: "info-circle",
    size: 3,
    dataAttributes: {
      'data-test-id': `payment-info-icon-${handsetIndex}`
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      left: 1
    }
  }, /*#__PURE__*/_react.default.createElement(StyledInteraction, {
    onClick: () => setPaymentModalOpen(true),
    isResponsive: true,
    dataAttributes: {
      'data-test-id': `payment-info-title-${handsetIndex}`
    }
  }, FinancingWithBanks !== null && FinancingWithBanks !== void 0 ? FinancingWithBanks : `${_services.Services.locale.localeString('Recommendation.upTo')} ${termDuration} ${_services.Services.locale.localeString('Recommendation.installments')}`)))))));
};
var _default = Prices;
exports.default = _default;